// Hook do usuwania procesu

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IDeleteProcessRequest {
  id: number;
}

const deleteProcess = (data: IDeleteProcessRequest): Promise<void> =>
  axios.delete(`/dev-studio/process/${data.id}`);

export const useDeleteProcess = (
  options?: UseMutationOptions<void, IError, IDeleteProcessRequest>
) => useMutation<void, IError, IDeleteProcessRequest>(deleteProcess, options);
